export const EXECUTION_STATUS = {
  STARTED: '_STARTED',
  FINISHED: '_FINISHED',
  ERROR: '_ERROR',
};

export const GET_CARS = 'GET_CARS';
